import { render } from "./Mb052.vue?vue&type=template&id=c6bd97f4&scoped=true"
import script from "./Mb052.vue?vue&type=script&lang=js"
export * from "./Mb052.vue?vue&type=script&lang=js"

import "./Mb052.vue?vue&type=style&index=0&id=c6bd97f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6bd97f4"]])

export default __exports__